let cachedEnv = null;
let pending = null;

/**
 * Fetch ONE_XP env values from the backend.
 * Returns an object: { ONE_XP_BASE_URL, ONE_XP_FAAS_URL }
 */
export async function getOneXpEndpoints({ forceReload = false } = {}) {
  if (!forceReload && cachedEnv) return cachedEnv;
  if (!forceReload && pending) return pending;

  pending = fetch("/api/one-xp-env", {
    method: "GET",
    credentials: "same-origin"
  })
    .then(async (res) => {
      if (!res.ok) {
        const text = await res.text().catch(() => "");
        throw new Error(`Failed to load env: ${res.status} ${text}`);
      }
      return res.json();
    })
    .then((json) => {
      cachedEnv = json;
      pending = null;
      return json;
    })
    .catch((err) => {
      pending = null;
      throw err;
    });

  return pending;
}
